import { Injectable } from "@angular/core";
import { API_URL, OperationType } from "common/constants/sm-constants";
import { ApplicantsModel } from "common/models/page-models/applicants/applicant-table/applicant-grid.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { DataService } from "../../base-data-services/data.service";

@Injectable({
    providedIn: 'root',
  })
  export class ResentApplicant extends DataService<ApplicantsModel> {
    constructor(protected ss: SystemService, protected http: SmApiService) {
      super(ss, API_URL.resetApplicant, http);
    }
  
    //    override getAPI_URL(): API_URL {
    //         return API_URL.getDocumentTypeList;
    //       }
  
    override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
      return environment.apiUrl + this.getAPI_URL();
    }
  
    createInstance(): ApplicantsModel {
      return new ApplicantsModel();
    }
  }